import React from 'react'
import CalendarHeader from '../calendar/CalendarHeader'
import Calendar from '../calendar/Calendar'
import CalendarDays from '../calendar/CalendarDays'

class ScheduleCalendarView extends React.Component {

  calendarDays () {
    return (
      [
        {id: 1, day: 'Sun'},
        {id: 2, day: 'Mon'},
        {id: 3, day: 'Tue'},
        {id: 4, day: 'Wed'},
        {id: 5, day: 'Thu'},
        {id: 6, day: 'Fri'},
        {id: 7, day: 'Sat'}
      ]
    )
  }

  render () {
    return (
      <div id='calendar-tab'>
        <CalendarHeader
          onMonthChange={this.props.changeData}
          requested_date={this.props.requested_date}
        />
        <div className='days-name'>
          <CalendarDays
            days={this.calendarDays()}
          />
        </div>
        <div className='calendar'>
          <Calendar
            data={this.props.data}
            manageTimelineData={this.props.manageTimelineData}
            handleItemClick={this.props.handleItemClick}
            display_modal={this.props.display_modal}
            show_paid_leave={this.props.show_paid_leave}
            show_job_protected_leave={this.props.show_job_protected_leave}
            summary_date={this.props.summary_date}
            onHelpfulCheck={this.props.onHelpfulCheck}
            handleJustLookingClick={this.props.handleJustLookingClick}
            show_hidden_tasks={this.props.show_hidden_tasks}
            handleCustomTaskDelete={this.props.handleCustomTaskDelete}
            handleCustomTaskClick={this.props.handleCustomTaskClick}
            custom_task_modal={this.props.custom_task_modal}
            handleCustomTaskChange={this.props.handleCustomTaskChange}
            isLeavePlanPartner={this.props.isLeavePlanPartner}
          />
        </div>
      </div>
    )
  }
}

export default ScheduleCalendarView